import { render } from "./ElementItem.vue?vue&type=template&id=fe585e46"
import script from "./ElementItem.vue?vue&type=script&lang=js"
export * from "./ElementItem.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__